import { Editor } from '@tinymce/tinymce-react'
import { FormControl } from 'baseui/form-control'
import { Input } from 'baseui/input'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal'
import useModalResources from './useModalResources'

const ModalResources = ({
  isOpen,
  close,
  selectedProductType,
  resources,
  tinymceKey,
  updateResources,
  saveResources,
  isSavingResources,
}) => {
  const {t, saleScript, learningLink, emailTemplateLink, objections} = useModalResources(resources)

  return (
    <Modal
      onClose={close}
      isOpen={isOpen}
      overrides={{
        Dialog: {
          style: {
            width: '80vw',
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <ModalHeader>
        {t('additionalProductsManagement:resources.modal_title')} {selectedProductType[0]?.label}
      </ModalHeader>
      <ModalBody>
        <FormControl label={t('additionalProductsManagement:resources.learning_link')}>
          <Input
            id='learning-link-input'
            value={learningLink}
            onChange={e => updateResources('learning_link', e.target.value)}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.email_template_link')}>
          <Input
            id='email-template-link-input'
            value={emailTemplateLink}
            onChange={e => updateResources('email_template_link', e.target.value)}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.sale_script')}>
          <Editor
            id='sale-script-editor'
            apiKey={tinymceKey}
            init={{
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'code',
                'wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            }}
            initialValue={saleScript}
            onChange={e => updateResources('sale_script', e.target.getContent())}
          />
        </FormControl>
        <FormControl label={t('additionalProductsManagement:resources.objections')}>
          <Editor
            apiKey={tinymceKey}
            id='objections-editor'
            init={{
              plugins: [
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'preview',
                'anchor',
                'searchreplace',
                'visualblocks',
                'code',
                'fullscreen',
                'insertdatetime',
                'media',
                'table',
                'code',
                'wordcount',
              ],
              toolbar:
                'undo redo | formatselect | ' +
                'bold italic backcolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
            }}
            initialValue={objections}
            onChange={e => updateResources('objections', e.target.getContent())}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind='tertiary' onClick={close}>
          {t('additionalProductsManagement:resources.cancel')}
        </ModalButton>
        <ModalButton onClick={saveResources} isLoading={isSavingResources} kind='primary'>
          {t('additionalProductsManagement:resources.save')}
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default ModalResources
